import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ColabsManagerComponent } from './colabs-manager/colabs-manager.component';
import { ColabsListingComponent } from './colabs-manager/colabs-listing/colabs-listing.component';
import { ColabsRegistrationComponent } from './colabs-manager/colabs-registration/colabs-registration.component';
import { ColabsImportComponent } from './colabs-manager/colabs-import/colabs-import.component';
import { ColabsBlockComponent } from './colabs-manager/colabs-block/colabs-block.component';
import { ColabsAutoUpdateComponent } from './colabs-manager/colabs-autoupdate/colabs-autoupdate.component';
import { ReportsComponent } from '../../components/reports/reports.component';

import { CompanyDetailComponent } from './company-detail/company-detail.component';
import { InternalRegistrationCompanyComponent } from './internal-registration-company/internal-registration-company.component';
import { AddressesComponent } from './addresses/addresses.component';
import { AuthGuard } from '../../guards/auth.guard';
import { PortalExternalRedirectComponent } from '../../components/portal-external-redirect/portal-external-redirect.component';

const children = [
  { path: 'meus-dados', component: InternalRegistrationCompanyComponent },
  { path: 'enderecos', component: AddressesComponent },
  { path: 'detalhe/:companyId', component: CompanyDetailComponent },
  {
    path: 'parcerias-proprias/criar-nova',
    component: PortalExternalRedirectComponent,
    data: { portalPath: '/dashboard/parcerias-exclusivas/cadastrar' },
  },
  {
    path: 'parcerias-proprias/alterar/:id',
    component: PortalExternalRedirectComponent,
    data: { portalPath: '/dashboard/parcerias-exclusivas/cadastrar', useIdQuery: true },
  },
  {
    path: 'parcerias-proprias/detalhe/:id',
    component: PortalExternalRedirectComponent,
    data: { portalPath: '/dashboard/parcerias-exclusivas/cadastrar', useIdQuery: true },
  },
  { path: 'manage', component: ColabsManagerComponent, children: [
      { path: '', component: ColabsListingComponent, outlet: 'colabmanagersection' },
      { path: 'colabs', component: ColabsListingComponent, outlet: 'colabmanagersection' },
      { path: 'add', component: ColabsRegistrationComponent, outlet: 'colabmanagersection' },
      { path: 'import', component: ColabsImportComponent, outlet: 'colabmanagersection' },
      { path: 'bulk-block', component: ColabsBlockComponent, outlet: 'colabmanagersection' },
      { path: 'autoupdate', component: ColabsAutoUpdateComponent, outlet: 'colabmanagersection' },
      { path: 'reports', component: ReportsComponent, outlet: 'colabmanagersection' },
      { path: 'edit/:employeeId', component: ColabsRegistrationComponent, outlet: 'colabmanagersection' },
    ]
  },
];

export const routes: Routes = [
  { path: 'empresa', canActivate: [AuthGuard], children },
  { path: 'company', canActivate: [AuthGuard], children },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CompanyRoutingModule {}
